import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';

Vue.use(Vuex)

var expire = new Date();
expire.setHours(expire.getHours()+0.1);
const vuexLocalStorage = new VuexPersist({
  expires: expire,
  key: 'memex',
  storage: window.localStorage
})

export default new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state: {
    //saved Bookmark journey
    bookmark:null,
    //toggle if is journey visualization active
    isJourneyOrSingleStory:0,
    //suggeston create new story loading
    isSuggestionLoading:false,
    //suggestion search Text
    suggestionSearchText:"",
    //suggestion search btn press
    suggestionSearchBtn:false,
    //suggestion navbar on createnewstory only image
    isToggleSuggestionOnlyImageEnable:false,
    //suggestion navbar on createnewstory
    isToggleSuggestionEnable:false,
    //change state when i edit a story end i need to reload the stories
    isStoryEditediNeedToReloadStories:true,
    //menu
    isdrawerOpen:false,
    //
    isDialogMediaPlayerClosed:false,
    //current list of stories carousel to iterate on singleStoryView
    currentListOfStoriesCarousel:[],
    //single story tags for header
    singleStoryTags:[],
    //single story title for header
    singleStoryTitle:"",
    //single story position for header
    singleStoryPositionOnMap:"",
    //
    singleStoryGeolocalizationOnMap:{lat:null,lng:null},
    /////////////////////JOURNEY
    // array of current user public journeys
    currentUserJourneysPublished:[],
    // array of saved journeys
    currentUserJourneysDraft:[],
    // array of public journeys Near me
    currentAllPublicNearMeJourneys:[],
    //array of all pubic journeys
    currentallPublicJourneys:[],
////////////////////////////
    // array of current user public stories
    currentUserStoriesPublished:[],
    // array of saved stories
    currentUserStoriesDraft:[],
    // array of public stories Near me
    currentAllPublicNearMeStories:[],
    //array of all pubic stories
    currentAllPublicStories:[],
    // object of current selected single story detail
    selectedSingleStory:null,
    // id of current selected single story detail
    selectedSingleStoryID:0,
    //in create/edit is editable the title and the map of the story ?
    isEditTitleAndMapStory:false,
    //Terms and conditions
    isTermsAndCondition:false,
    //value of the searchBar
    searchBarTextValue:"",
    //value of the searchBar for journey
    searchBarTextValueJourney:"",
    //array of filters selected tags
    listOfSelectedTag:[],
    //user selected language
    preferredLanguage:null,
    //jwt  - access token
    access_token: null,
    //information of the logged in user
    user:null,
    //enable / disable the loader on the page page load
    loading: false,
    //enable / disable the loader when story is upload
    loadingStory: {status:false,text:""},
    //enable / disable the loader when journey/collection is upload
    loadingJourney: {status:false,text:""},
    //temp object used when create or edit a story
    tempMediaOnIndexDB:{imageObj:"",imageTitle:"",imageSize:0,imageID:null,videoID:null,videoTitle:"",videoSize:0,audios:[],attachments:[],images:[]},
    //it contains all the information of a single Journey when it is being created or edited
    newJourneys:{id:null,storiesArrayObjectIdDescription:[],journeyTitle:"",journeyDescription:"",journeyBackgroundColor:null,isPublic:false,isJourney:true},
    //it contains all the information of a single story when it is being created or edited
    newStories:{marker:null,tags:[],isStoryID:null,checkboxPublic:false,storyTitle:"",content:[], imageFileRaw:null,imageFile:null,imageType:"image/jpeg",imageObj:null,audioFiles:[],audioFilesRaw:[],audioTypes:[],audioFileTitles:[],imageFiles:[],imageFilesRaw:[],imageTypes:[],imageFileTitles:[],attachmentsFiles:[],attachmentsFilesRaw:[],attachmentsTypes:[],attachmentsFileTitles:[],videoFileRaw:null,videoFile:null,videoType:"video/mp4",KGselectedOnlyImage:[],KGArrayText:[]},
    //font size to use for the story content
    currentFontSize:16,
    //boolean variable - "remember me" of the login page
    userInfoStoredinLocalStorage:false,
    //event messages
    snackbar:{color:'',text:'',active:false},
    //PRE LOAD MESSAGE
    dialogPreUpload:{color:'',text:'',active:false,isSuccess:false},
    //counts the times the user has accessed the portal from that browser
    userLoginCounter:0,
    //state of the filter window - open / closed
    dialogFilterTag:false,
    //state of save history before exiting - open / closed
    dialogSaveBeforeExit:false,
    //check if the user has decided to skip the preferences selection the first time he logs in
    userHasSkippedFilterTag:false,
    //0 = user created Journey list , 1= View all Journey
    isCreatedOrviewJourneys:0,
    // 0 = all the Journeys (country) , 1 = all Journeys near me
    isAllOrNearmeJourneys:0,
    // 0 = user saved Journeys , 1 = user published journeys
    isSavedOrPublishedJourneys:0,
    // 0 = user created story list , 1= View all story
    isCreatedOrviewStories:0,
    // 0 = all the story (country) , 1 = all story near me
    isAllOrNearme:0,
    // 0 = user saved story , 1 = user published story
    isSavedOrPublished:0,
    //get the current array of published stories to iterate
    //
},
getters:{
  getLoadingTimeStampStart:() =>{
    return localStorage.getItem("loadingTimeStampStart")
  },
  getBookmark:state=>{
    return state.bookmark
  },
  getIsSuggestionLoading:state=>{
    return state.isSuggestionLoading
  },
  getSuggestionSearchText:state=>{
    return state.suggestionSearchText
  },
  getSuggestionSearchBtn:state=>{
    return state.suggestionSearchBtn
  },
  getIsToggleSuggestionOnlyImageEnable:state=>{
    return state.isToggleSuggestionOnlyImageEnable
  },
  getIsToggleSuggestionEnable:state=>{
    return state.isToggleSuggestionEnable
  },
  getIsStoryEditediNeedToReloadStories:state=>{
    return state.isStoryEditediNeedToReloadStories
  },
  
  getIsdrawerOpen:state=>{
    return state.isdrawerOpen
  },
  getIsDialogMediaPlayerClosed:state=>{
    return state.isDialogMediaPlayerClosed
  },

  getCurrentListOfStoriesCarousel:state=>{
    return state.currentListOfStoriesCarousel
  },
  
  getSingleStoryTags:state=>{
    return state.singleStoryTags
  },
  getSingleStoryTitle:state=>{
    return state.singleStoryTitle
  },
  getSingleStoryPositionOnMap:state=>{
    return state.singleStoryPositionOnMap
  },
  getSingleStoryGeolocalizationOnMap:state=>{
    return state.singleStoryGeolocalizationOnMap
  },
  //////////////////////////////
  getCurrentUserJourneysPublished:state=>{
    return state.currentUserJourneysPublished
  },
  getCurrentUserJourneysDraft:state=>{
    return state.currentUserJourneysDraft
  },
  getCurrentAllPublicNearMeJourneys:state=>{
    return state.currentAllPublicNearMeJourneys
  },
  getCurrentAllPublicJourneys:state=>{
    return state.currentallPublicJourneys
  },
  /////////////////////////////////
  getCurrentUserStoriesPublished:state=>{
    return state.currentUserStoriesPublished
  },
  getCurrentUserStoriesDraft:state=>{
    return state.currentUserStoriesDraft
  },
  getCurrentAllPublicNearMeStories:state=>{
    return state.currentAllPublicNearMeStories
  },
  getCurrentAllPublicStories:state=>{
    return state.currentAllPublicStories
  },
  getSelectedSingleStory:state=>{
    return state.selectedSingleStory
  },
  getSelectedSingleStoryID:state=>{
    return state.selectedSingleStoryID
  },
  getIsEditTitleAndMapStory:state=>{
    return state.isEditTitleAndMapStory
  },
  getIsCreatedOrviewJourneys: state=>{
    return state.isCreatedOrviewJourneys
  },
  getIsAllOrNearmeJourneys: state=>{
    return state.isAllOrNearmeJourneys
  },
  getIsSavedOrPublishedJourneys: state=>{
    return state.isSavedOrPublishedJourneys
  },
  getIsCreatedOrviewStories: state=>{
    return state.isCreatedOrviewStories
  },
  getIsJourneyOrSingleStory: state=>{
    return state.isJourneyOrSingleStory
  },
  getIsAllOrNearme: state=>{
    return state.isAllOrNearme
  },
  getIsSavedOrPublished: state=>{
    return state.isSavedOrPublished
  },
  getTermsAndCondition: state=>{
    return state.isTermsAndCondition
  },
  getSearchBarTextValueJourney:state=>{
    return state.searchBarTextValueJourney
  },
  getSearchBarTextValue: state=>{
    return state.searchBarTextValue
  },
  getUserHasSkippedFilterTag: state => {
    return state.userHasSkippedFilterTag
  },
  getDialogSaveBeforeExit: state => {
    return state.dialogSaveBeforeExit
  },
  getDialogFilterTag: state => {
    return state.dialogFilterTag
  },
  getUserInfoStoredinLocalStorage: state => {
    return state.userInfoStoredinLocalStorage
  },
  getUser: state => {
    return state.user
  },
  getDialogPreUpload:state=>{
    return state.dialogPreUpload
  },
  getSnackbar: state => {
    return state.snackbar
  },
  arrayObjectStory: state => {
    return state.arrayObjectStory
  }, 
  arrayObjectStoryLocation: state => {
    return state.arrayObjectStoryLocation
  },
  getListOfSelectedTag: state => {
    return state.listOfSelectedTag
  },
  getCurrentFontSize: state => {
    return state.currentFontSize
  },
  getUserLoginCounter: state => {
    return state.userLoginCounter
  },
  getPreferredLanguage: state => {
    return state.preferredLanguage
  },
  getAccessToken: state => {
    return state.access_token
  },
  getLoading: state => {
    return state.loading
  },
  getLoadingStory: state => {
    return state.loadingStory
  },
  getLoadingJourney: state =>{
    return state.loadingJourney
  },
  getPreferences: state => {
    return state.preferences
  },
  getNewStories: state => {
    return state.newStories
  },
  getNewJourneys: state=>{
    return state.newJourneys
  },
  getTempMediaOnIndexDB:state=>{
    return state.tempMediaOnIndexDB
  }
},
  mutations: {
    setBookmark(state,payload){
state.bookmark=payload
localStorage.setItem('bookmark',payload)
    },
    setUserLoginData(state,payload){
      state.user=payload.user
      state.preferredLanguage=payload.user.language
      console.log('payload.user.language',payload.user.language)
      state.access_token=payload.jwt
      localStorage.setItem('access_token', payload.jwt)
      state.preferredLanguage=payload.language
    },
    setJourneyTitle(state,payload){
      state.newJourneys.journeyTitle=payload
    },
    /////////////////////////
    setJourneyDescription(state,payload){
      state.newJourneys.journeyDescription=payload
    },
    //to use when add a story in a new journey / existing journey
    setJourneyStoriesArrayObjectIdDescription(state,payload){
    state.newJourneys.storiesArrayObjectIdDescription.push(payload)
    },
    setJourneyStoriesArrayObjectIdDescriptionDescriptionStoryJourney(state,payload){

      state.newJourneys.storiesArrayObjectIdDescription[payload.index].descriptionStoryJourney=payload.description
      state.newJourneys.storiesArrayObjectIdDescription[payload.index].storyID=payload.storyId
    },

    swapDownJourneyStoriesArrayObjectId(state,payload){
      let temp =state.newJourneys.storiesArrayObjectIdDescription[payload+1]
      state.newJourneys.storiesArrayObjectIdDescription[payload+1]=state.newJourneys.storiesArrayObjectIdDescription[payload]
      state.newJourneys.storiesArrayObjectIdDescription[payload]=temp
    },
    swapUpJourneyStoriesArrayObjectId(state,payload){
      let temp =state.newJourneys.storiesArrayObjectIdDescription[payload-1]
      state.newJourneys.storiesArrayObjectIdDescription[payload-1]=state.newJourneys.storiesArrayObjectIdDescription[payload]
      state.newJourneys.storiesArrayObjectIdDescription[payload]=temp
    },
    ////////////////////////////////////
    setJourneyBackgroundColor(state,payload){
      state.newJourneys.backgroundColor=payload
    },
    setJourneyUnorderedOrOrdered(state,payload){
state.newJourneys.isJourney = payload
    },
    setSuggestionSearchText(state,payload){
      state.suggestionSearchText=payload
    },
    setSuggestionSearchBtn(state,payload){
      state.suggestionSearchBtn=payload
    },
    setIsToggleSuggestionOnlyImageEnable(state,payload){
      state.isToggleSuggestionOnlyImageEnable=payload
    },
    setIsToggleSuggestionEnable(state,payload){
      state.isToggleSuggestionEnable=payload
    },
    setIsSuggestionLoading(state,payload){
      state.isSuggestionLoading=payload
    },
    setisStoryEditediNeedToReloadStories(state,payload){
      state.isStoryEditediNeedToReloadStories=payload
    },
    
    setIsdrawerOpen(state,payload){
      state.isdrawerOpen=payload
    },
    clearNewStory(state){
      state.newStories = {marker:null,tags:[],isStoryID:null,checkboxPublic:false,storyTitle:"",content:[], imageFileRaw:null,imageFile:null,imageType:"image/jpeg",imageObj:null,audioFiles:[],audioFilesRaw:[],audioTypes:[],audioFileTitles:[],videoFileRaw:null,videoFile:null,videoType:"video/mp4",attachmentsFiles:[],attachmentsFilesRaw:[],attachmentsTypes:[],attachmentsFileTitles:[],KGselectedOnlyImage:[],KGArrayText:[]}
      state.tempMediaOnIndexDB={imageObj:null,imageTitle:"",imageSize:0,imageID:null,videoID:null,videoTitle:"",videoSize:0,audios:[],images:[],attachments:[]}
    },
    clearNewJourney(state){
      state.newJourneys={storiesArrayObjectIdDescription:[],journeyTitle:"",journeyDescription:"",journeyBackgroundColor:1,isPublic:false,isJourney:true}

    },
    removeAllattachmentBlobOnNewStory(state){
      state.newStories.audioFilesRaw= []
    },
    removeSingleattachmentBlobOnNewStory(state, attachment) {
      state.newStories.audioFilesRaw.splice(attachment,1)
    },
    removeAllAudioBlobOnNewStory(state){
      state.newStories.audioFilesRaw= []
    },
    removeSingleAudioBlobOnNewStory(state, audio) {
      state.newStories.audioFilesRaw.splice(audio,1)
    },
    removeAllAudioOntempMediaOnIndexDB(state){
      state.tempMediaOnIndexDB.audios.forEach((x,index) => { 
        if( x.id ==null){
            //console.log("audio id==null");
            state.tempMediaOnIndexDB.audios.splice(index,1)}
        else{
          //console.log("audio id!=null",x)
        }})

    },
    removeAllImagesOntempMediaOnIndexDB(state){
      state.tempMediaOnIndexDB.images.forEach((x,index) => { 
        if( x.id ==null){
            //console.log("audio id==null");
            state.tempMediaOnIndexDB.images.splice(index,1)}
        else{
          //console.log("audio id!=null",x)
        }})

    },
    removeAttachmentOntempMediaOnIndexDB(state, attachment) {
      state.tempMediaOnIndexDB.attachments.splice(attachment,1)
    },
    removeAudioOntempMediaOnIndexDB(state, audio) {
      state.tempMediaOnIndexDB.audios.splice(audio,1)
    },
    removeImagesOntempMediaOnIndexDB(state, images) {
      state.tempMediaOnIndexDB.images.splice(images,1)
    },
    addAttachmentOntempMediaOnIndexDB (state, attachment) {
      state.tempMediaOnIndexDB.attachments.push(attachment)
    },
    addAudioOntempMediaOnIndexDB (state, audio) {
      state.tempMediaOnIndexDB.audios.push(audio)
    },
    addImagesOntempMediaOnIndexDB (state, images) {
      state.tempMediaOnIndexDB.images.push(images)
    },
    addimageObjOntempMediaOnIndexDB (state, url) {
      state.tempMediaOnIndexDB.imageObj = url
    },
    addImageTitleOntempMediaOnIndexDB (state, title) {
      state.tempMediaOnIndexDB.imageTitle = title
    },
    addImageSizeOntempMediaOnIndexDB (state, size) {
      state.tempMediaOnIndexDB.imageSize = size
    },
    addVideoTitleOntempMediaOnIndexDB (state, title) {
      state.tempMediaOnIndexDB.videoTitle = title
    },
    addVideoSizeOntempMediaOnIndexDB (state, size) {
      state.tempMediaOnIndexDB.videoSize = size
    },
    addImageIDOntempMediaOnIndexDB (state, id) {
      state.tempMediaOnIndexDB.imageID = id
    },
    addVideoIDOntempMediaOnIndexDB (state, id) {
      state.tempMediaOnIndexDB.videoID = id
    },
    addBlobVideoNewStories (state, fileblob) {
      state.newStories.videoFileRaw = fileblob
    },
    addBlobImageNewStories (state, fileblob) {
      state.newStories.imageFileRaw = fileblob
    },
    addBlobAudioNewStories(state, fileblob) {
      state.newStories.audios.push(fileblob)
    },
    addBlobImagesNewStories(state, fileblob) {
      state.newStories.images.push(fileblob)
    },
    removeAllAudiosNewStories(state) {
      state.newStories.audios=[]
    },
    removeAllImagesNewStories(state) {
      state.newStories.images=[]
    },

    setIsDialogMediaPlayerClosed(state,payload){
      state.isDialogMediaPlayerClosed=payload
    },
    setDialogSaveBeforeExit(state,payload){
      state.dialogSaveBeforeExit=payload
    },
    setDialogFilterTag(state,payload){
      state.dialogFilterTag=payload
    },
    setSearchBarTextValueJourney(state,payload){
      state.searchBarTextValueJourney = payload
    },
    setSearchBarTextValue(state,payload){
      state.searchBarTextValue= payload
    },
    setUser(state, payload) {
      state.user = payload
    },
    setDialogPreUpload(state,payload) {
      state.dialogPreUpload=payload
      setTimeout(() =>{
        state.dialogPreUpload= {
    color: '',
    text: '',
    isSuccess:false,
    active: false
        }}, 650000)
    },
    setSnackbar(state,payload) {
      state.snackbar=payload
      setTimeout(() =>{
        state.snackbar= {
    color: '',
    text: '',
    active: false
        }}, 6500)

    },
    setUserInfoStoredinLocalStorage(state, payload) {
      state.userInfoStoredinLocalStorage = payload
    },
    setUserHasSkippedFilterTag(state, payload) {
      state.userHasSkippedFilterTag = payload
    },
    setArrayObjectStory(state, payload) {
      state.arrayObjectStory = payload
    },
    setArrayObjectStoryLocation(state, payload) {
      state.arrayObjectStoryLocation = payload
    },
    setListOfSelectedTag(state, payload) {
      state.listOfSelectedTag = payload
    },
    increaseUserLoginCounter (state) {
      state.userLoginCounter++
    },
    increaseCurrentFontSize (state) {
      if (state.currentFontSize<26){
        state.currentFontSize++
      }
    },
    decreaseCurrentFontSize (state) {
      if (state.currentFontSize>=11){
        state.currentFontSize--
      }
    },
    setPreferredLanguage (state, payload) {
      state.preferredLanguage = payload
    },
    setAccessToken (state, payload) {
      localStorage.setItem('access_token', payload)
      state.access_token = payload
    },
    setPreferences (state, payload) {
      localStorage.setItem('Preferences', payload)
      state.preferences = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setLoadingStory (state, payload) {
      state.loadingStory = payload
    },
    setLoadingJourney(state,payload){
      state.loadingJourney = payload
    },
    logout: state => {
      state.access_token = null;
      state.user=''
      localStorage.removeItem("accessToken");
      localStorage.removeItem("access_token");
      localStorage.removeItem("user")
      localStorage.removeItem("memex")
      console.log('store logout')
    },
    setNewJourney(state,payload){
    state.newJourneys = payload
    },
    setNewStories (state, payload) {
      state.newStories = payload
    },
    updateContent (state, payload) {
      state.newStories.content = payload
    },
    setNewStoriesTags (state, payload) {
      state.newStories.tags = payload
    },
    setTempMediaOnIndexDB(state,payload){
      state.tempMediaOnIndexDB = payload
    },
    setTermsAndCondition(state,payload){
      state.isTermsAndCondition = payload
    },
    setIsCreatedOrviewJourneys(state,payload){
      state.isCreatedOrviewJourneys = payload
    },
    setIsAllOrNearmeJourneys(state,payload){
      state.isAllOrNearmeJourneys = payload
    },
    setIsSavedOrPublishedJourneys(state,payload){
      state.isSavedOrPublishedJourneys = payload
    },
    setIsCreatedOrviewStories(state,payload){
      state.isCreatedOrviewStories = payload
    },
    setIsJourneyOrSingleStory(state,payload){
      state.isJourneyOrSingleStory = payload
    },
    setIsAllOrNearme(state,payload){
      state.isAllOrNearme = payload
    },
    setIsSavedOrPublished(state,payload){
      state.isSavedOrPublished = payload
    },
    setIsEditTitleAndMapStory(state,payload){
      state.isEditTitleAndMapStory = payload
    },
    setSelectedSingleStory(state,payload){
      state.selectedSingleStory = payload
    },
    setSelectedSingleStoryID(state,payload){
      state.selectedSingleStoryID = parseInt(payload)
    },
    ///////////////////////////////////////////////
    setCurrentUserJourneysPublished(state,payload){
      state.currentUserJourneysPublished = payload
    },
    setCurrentUserJourneysDraft(state,payload){
      state.currentUserJourneysDraft = payload
    },
    setCurrentAllPublicNearMeJourneys(state,payload){
      state.currentAllPublicNearMeJourneys = payload
    },
    setCurrentallPublicJourneys(state,payload){
      state.currentallPublicJourneys = payload
    },
    /////////////////////////////////
    setCurrentUserStoriesPublished(state,payload){
      state.currentUserStoriesPublished = payload
    },
    setCurrentUserStoriesDraft(state,payload){
      state.currentUserStoriesDraft = payload
    },
    setCurrentAllPublicNearMeStories(state,payload){
      state.currentAllPublicNearMeStories = payload
    },
    setCurrentAllPublicStories(state,payload){
      state.currentAllPublicStories = payload
    },
    setSingleStoryTags(state,payload){
      state.singleStoryTags = payload
      },
    setSingleStoryTitle(state,payload){
    state.singleStoryTitle = payload
    },
    setSingleStoryPositionOnMap(state,payload){
      state.singleStoryPositionOnMap = payload
    },
    setSingleStoryGeolocalizationOnMap(state,payload){
      state.singleStoryGeolocalizationOnMap = payload
    },
    setCurrentListOfStoriesCarousel(state,payload){
      state.currentListOfStoriesCarousel = payload
    }
  },
  actions: {
    swapUpJourneyStoriesArrayObjectId(context,payload){
      context.commit('swapUpJourneyStoriesArrayObjectId',payload)
    },
    swapDownJourneyStoriesArrayObjectId(context,payload){
      context.commit('swapDownJourneyStoriesArrayObjectId',payload)
    },
    setJourneyStoriesArrayObjectIdDescription(context,payload){
      context.commit('setJourneyStoriesArrayObjectIdDescription',payload)
    },
    setJourneyStoriesArrayObjectIdDescriptionDescriptionStoryJourney(context,payload){
      context.commit('setJourneyStoriesArrayObjectIdDescriptionDescriptionStoryJourney',payload)
    },
    setJourneyTitle(context,payload){
      context.commit('setJourneyTitle',payload)
    },
    setJourneyDescription(context,payload){
      context.commit('setJourneyDescription',payload)
    },
    setJourneyBackgroundColor(context,payload){
      context.commit('setJourneyBackgroundColor',payload)
    },
    setJourneyUnorderedOrOrdered(context,payload){
      context.commit('setJourneyUnorderedOrOrdered',payload)
    },
    setBookmark(context,payload){
context.commit('setBookmark',payload)
          },
    setIsSuggestionLoading(context,payload){
      context.commit('setIsSuggestionLoading',payload)
    },
    setSuggestionSearchText(context,payload){
      context.commit("setSuggestionSearchText",payload)
    },
    setSuggestionSearchBtn(context,payload){
context.commit('setSuggestionSearchBtn',payload)
    },
    setIsToggleSuggestionOnlyImageEnable(context,payload){
      context.commit("setIsToggleSuggestionOnlyImageEnable",payload)
    },
    setIsToggleSuggestionEnable(context,payload){
      context.commit("setIsToggleSuggestionEnable",payload)
    },
    setisStoryEditediNeedToReloadStories(context,payload){
      context.commit("setisStoryEditediNeedToReloadStories",payload)
    },
    setIsdrawerOpen(context,payload){
      context.commit("setIsdrawerOpen",payload)
    },
    setIsDialogMediaPlayerClosed(context,payload){
      context.commit("setIsDialogMediaPlayerClosed",payload)
    },
    setCurrentListOfStoriesCarousel(context,payload){
      context.commit("setCurrentListOfStoriesCarousel",payload)
    },
    setSingleStoryTags(context,payload){
      context.commit("setSingleStoryTags",payload)
    },
  setSingleStoryTitle(context,payload){
    context.commit("setSingleStoryTitle",payload)
  },
  setSingleStoryPositionOnMap(context,payload){
    context.commit("setSingleStoryPositionOnMap",payload)
  },
  setSingleStoryGeolocalizationOnMap(context,payload){
    context.commit("setSingleStoryGeolocalizationOnMap",payload)
  },
  //////////////////////////
  setCurrentUserJourneysPublished(context,payload){
    context.commit("setCurrentUserJourneysPublished",payload)
   },
   setCurrentUserJourneysDraft(context,payload){
    context.commit("setCurrentUserJourneysDraft",payload)
  },
   setCurrentAllPublicNearMeJourneys(context,payload){
    context.commit("setCurrentAllPublicNearMeJourneys",payload)
  },
   setCurrentallPublicJourneys(context,payload){
    context.commit("setCurrentallPublicJourneys",payload)
  },
  ///////////////////////////
  setCurrentUserStoriesPublished(context,payload){
    context.commit("setCurrentUserStoriesPublished",payload)
   },
   setCurrentUserStoriesDraft(context,payload){
    context.commit("setCurrentUserStoriesDraft",payload)
  },
   setCurrentAllPublicNearMeStories(context,payload){
    context.commit("setCurrentAllPublicNearMeStories",payload)
  },
   setCurrentAllPublicStories(context,payload){
    context.commit("setCurrentAllPublicStories",payload)
  },
    setSelectedSingleStory(context,payload){
      context.commit("setSelectedSingleStory",payload)
    },
    setSelectedSingleStoryID(context,payload){
      context.commit("setSelectedSingleStoryID",payload)
    },
    setIsEditTitleAndMapStory(context,payload){
      context.commit("setIsEditTitleAndMapStory",payload)
    },
    setIsCreatedOrviewJourneys(context,payload){
      context.commit("setIsCreatedOrviewJourneys",payload)
    },
    setIsAllOrNearmeJourneys(context,payload){
      context.commit("setIsAllOrNearmeJourneys",payload)
    },
    setIsSavedOrPublishedJourneys(context,payload){
      context.commit("setIsSavedOrPublishedJourneys",payload)
    },
    setIsCreatedOrviewStories(context,payload){
      context.commit("setIsCreatedOrviewStories",payload)
    },
    setIsJourneyOrSingleStory(context,payload){
      context.commit("setIsJourneyOrSingleStory",payload)
    },
    setIsAllOrNearme(context,payload){
      context.commit("setIsAllOrNearme",payload)
    },
    setIsSavedOrPublished(context,payload){
      context.commit("setIsSavedOrPublished",payload)
    },
    setSearchBarTextValueJourney(context,payload){
      context.commit("setSearchBarTextValueJourney",payload)
    },
    setSearchBarTextValue(context,payload){
      context.commit("setSearchBarTextValue",payload)
    },
    clearNewStory(context){
      context.commit("clearNewStory")
    },
    clearNewJourney(context){
      context.commit("clearNewJourney")
    },
    addBlobVideoNewStories(context,payload){
      context.commit("addBlobVideoNewStories",payload)
    },
    addBlobImageNewStories(context,payload){
      context.commit("addBlobImageNewStories",payload)
    },
    addBlobAudioNewStories(context,payload){
      context.commit("addBlobAudioNewStories",payload)
    },
    removeSingleAudioAudioBlobOnNewStory(context,payload){
      context.commit("removeSingleAudioAudioBlobOnNewStory",payload)
    },
    removeAllAudioBlobOnNewStory(context){
      context.commit("removeAllAudioBlobOnNewStory")
    },
    removeAllAudioOntempMediaOnIndexDB(context){
      context.commit("removeAllAudioOntempMediaOnIndexDB")
    },
    removeAllAudiosNewStories(context){
      context.commit("removeAllAudiosNewStories")
    },
    removeAllImagesOntempMediaOnIndexDB(context){
      context.commit("removeAllImagesOntempMediaOnIndexDB")
    },
    removeAllImagesNewStories(context){
      context.commit("removeAllImagesNewStories")
    },
    removeAudioOntempMediaOnIndexDB(context,payload){
      context.commit("removeAudioOntempMediaOnIndexDB",payload)
    },
    removeImagesOntempMediaOnIndexDB(context,payload){
      context.commit("removeImagesOntempMediaOnIndexDB",payload)
    },
    addAttachmentOntempMediaOnIndexDB(context,payload){
      context.commit("addAttachmentOntempMediaOnIndexDB",payload)
    },
    removeAttachmentOntempMediaOnIndexDB(context,payload){
      context.commit("removeAttachmentOntempMediaOnIndexDB",payload)
    },
    addImagesOntempMediaOnIndexDB(context,payload){
    context.commit("addImagesOntempMediaOnIndexDB",payload)
    },
    addAudioOntempMediaOnIndexDB(context,payload){
      context.commit("addAudioOntempMediaOnIndexDB",payload)
    },
    addimageObjOntempMediaOnIndexDB(context,payload){
      context.commit("addimageObjOntempMediaOnIndexDB",payload)
    },
    addImageTitleOntempMediaOnIndexDB(context,payload){
      context.commit("addImageTitleOntempMediaOnIndexDB",payload)
    },
    addImageSizeOntempMediaOnIndexDB(context,payload){
      context.commit("addImageSizeOntempMediaOnIndexDB",payload)
    },
    addVideoTitleOntempMediaOnIndexDB(context,payload){
      context.commit("addVideoTitleOntempMediaOnIndexDB",payload)
    },
    addImageIDOntempMediaOnIndexDB(context,payload){
      context.commit("addImageIDOntempMediaOnIndexDB",payload)
    },
    addVideoIDOntempMediaOnIndexDB(context,payload){
      context.commit("addVideoIDOntempMediaOnIndexDB",payload)
    },
    addVideoSizeOntempMediaOnIndexDB(context,payload){
      context.commit("addVideoSizeOntempMediaOnIndexDB",payload)
    },
    setDialogPreUpload(context,payload) {
      context.commit("setDialogPreUpload",payload)
    },
    setSnackbar(context,payload) {
      context.commit("setSnackbar",payload)
    },
    setUserHasSkippedFilterTag(context,payload) {
      context.commit("setUserHasSkippedFilterTag",payload)
    },
    setUserLoginData(context,payload) {
      context.commit("setUserLoginData",payload)
    },
    setPreferredLanguage(context,payload) {
      context.commit("setPreferredLanguage",payload)
    },
    setUserInfoStoredinLocalStorage(context,payload) {
      context.commit("setUserInfoStoredinLocalStorage",payload)
    },
    setArrayObjectStory (context,payload) {
      context.commit("setArrayObjectStory",payload)
    },
    setArrayObjectStoryLocation (context,payload) {
      context.commit("setArrayObjectStoryLocation",payload)
    },
    setListOfSelectedTag (context,payload) {
      context.commit("setListOfSelectedTag",payload)
    },
    increaseUserLoginCounter(context) {
      context.commit("increaseUserLoginCounter")
    },
    increaseCurrentFontSize (context) {
      context.commit("increaseCurrentFontSize")
    },
    decreaseCurrentFontSize (context) {
      context.commit("decreaseCurrentFontSize")
    },
    setDialogSaveBeforeExit(context,payload){
      context.commit("setDialogSaveBeforeExit",payload)
    },
    setDialogFilterTag(context,payload){
      context.commit("setDialogFilterTag",payload)
    },
    setCurrentFontSize (context,payload) {
      context.commit("setCurrentFontSize", payload)
    },
    setLoading (context,payload) {
      context.commit("setLoading", payload)
    },
    setLoadingStory (context,payload) {
      localStorage.setItem("loadingTimeStampStart",Math.floor(Date.now() / 1000))
      context.commit("setLoadingStory", payload)
    },
    setLoadingJourney(context,payload){
      localStorage.setItem("loadingTimeStampStart",Math.floor(Date.now() / 1000))
      context.commit("setLoadingJourney",payload)
    },
    setPreferences (context,payload) {
      context.commit("setPreferencess", payload)
    },
    setLoadingTimestampStart(){
      localStorage.setItem("loadingTimeStampStart",Math.floor(Date.now() / 1000))

    },
    setAccessToken (context,payload) {
      context.commit("setAccessToken", payload)
      localStorage.setItem("accessToken",payload)
    },
    setUser (context,payload) {
      context.commit("setUser", payload)
      localStorage.setItem("user",JSON.stringify(payload))
    },
    async logout(context) {
      context.commit("logout");
    },
    setNewJourney (context,payload) {
      context.commit("setNewJourney", payload)
    },
    setNewStories (context,payload) {
      context.commit("setNewStories", payload)
    },
    setNewStoriesTags (context,payload) {
      context.commit("setNewStoriesTags", payload)
    },
    setTempMediaOnIndexDB(context,payload){
      context.commit("setTempMediaOnIndexDB",payload)
    },
    setTermsAndCondition(context,payload){
      context.commit("setTermsAndCondition",payload)
    },
    updateContent (context, payload) {
      context.commit("updateContent", payload)
    }
  }
})